import axios from "axios";
import $socket from "@/plugins/socket-instance";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    savingInProgress: false,
    isLoadedDiagnosticParameters: false,
    nowUpdatingConfigForParameterWithId: false,
    repairtime_id: null,
    diagnosticParameters:[],
    diagnostic: {
      replacements: {},
      regulations: {}
    },
    isNowUpdatingTypes: [],
    regulationsParams: {
      // Масло в двигателе  - пол года
      engine_oil: {
        condition: false,
        days: 182,
      },
      // Воздушный фильтр - пол года
      air_filter: {
        condition: false,
        days: 182,
      },
      // Салонный фильтр - пол года
      cabin_filter: {
        condition: false,
        days: 182,
      },
      //Жидкость ГУР - 2 года
      power_steering_fluid: {
        condition: false,
        days: 730,
      },
      // Свечи зажигания - (иридий, платина) - 3 года, (никель) - 1 год (данные берутся из диагностики механиком)
      spark_plug: {
        condition: true,
        condition_parameter: 'spark_plug',
        iridium_platinum_spark_plug:{ // Свечи зажигания - (иридий, платина) - 3 года
          days: 1095
        },
        nickel_spark_plug:{ // (никель) - 1 год (данные берутся из диагностики механиком)
          days: 365
        }
      },
      // Охлаждающая жидкость - 2 года
      coolant: {
        condition: false,
        days: 730,
      },
      // Топливный фильтр - (погружной) - 3 года,  наружний - 1 год (данные берутся из диагностики механика)
      fuel_filter:  {
        condition: true,
        condition_parameter: 'fuel_filter',
        tank_filter:{ // Фильтр в баке - (погружной) - 3 года
          days: 1095
        },
        external_filter:{ // Внешний фильтр - 1 год (данные берутся из диагностики механика)
          days: 365
        }
      },
      // Жидкость в КПП - 2 года
      fluid_in_gearbox: {
        condition: false,
        days: 730,
      },
      //Аккумулятор нет данных
      battery: null,
      // Жидкость в переднем мосту - 3 года
      front_axle_fluid: {
        condition: false,
        days: 1095,
      },
      // Жидкость в раздатке - 3 года
      fluid_in_transfer_case: {
        condition: false,
        days: 1095,
      },
      // Развал-схождение - 6 мес
      camber_and_toe: {
        condition: false,
        days: 182,
      },
      // Жидкость в заднем мосту - 3 года
      fluid_rear_axle: {
        condition: false,
        days: 1095,
      },
      lights: "",
      tires: "",
      windscreen_washer: "",
      // Тормозная жидкость - 2 года
      brake_fluid: {
        condition: false,
        days: 730,
      },
      // Тормозные диски перед
      front_brake_discs: {
        condition: false,
        days: 1460,
      },
      //Тормозные колодки перед
      front_pads: {
        condition: false,
        days: 547,
      },
      // Тормозные диски зад - 5 лет
      rear_brake_discs: {
        condition: false,
        days: 730,
      },
      // Тормозные колодки зад - 2 года
      rear_pads: {
        condition: false,
        days: 730,
      },
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    setDiagnostic(state, data) {
      //если поле из массива пустое - заполним его пустыми значениями
      let fields = ['replacements',
          'regulations',
          'comments_custom',
          'brand',
          'price',
      ];
      fields.forEach((field)=>{
        if (data[field] === null && data.data) {
          let tmp = {};
          data.data.forEach((item) => {
            tmp[item.type] =
                data[field] && data[field][item.type];
          });
          data[field] = tmp;
        }
      })

      state.diagnostic = data;
    },
  },
  actions: {
    async setParameterConfig({ commit, state, dispatch }, payload){
      updateField(state, { path: "nowUpdatingConfigForParameterWithId", value: payload.id });
      return await axios
          .put(this._vm.$apiURL + "/diagnostic_parameters/"+payload.id, payload)
          .then((response) => {
            if (response.data && response.data.status === "success" && response.data.data) {
              updateField(state, { path: "diagnosticParameters", value: response.data.data });
            }
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "nowUpdatingConfigForParameterWithId", value: null });
          });
    },
    async getParameters({ commit, state, dispatch }){
      updateField(state, { path: "isLoadedDiagnosticParameters", value: false });
      return await axios
          .get(this._vm.$apiURL + "/diagnostic_parameters")
          .then((response) => {
            if (response.data && response.data.status === "success" && response.data.data) {
              updateField(state, { path: "diagnosticParameters", value: response.data.data });
            }
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "isLoadedDiagnosticParameters", value: true });
          });
    },
    /**
     * Обновим diagnostic.data без лоадеров(реакция на событие полученное через сокеты)
     */
    async silentRefresh({ commit, state, dispatch }, payload) {
      if (state.repairtime_id === payload.order_item_id) {
        updateField(state, {
          path: "diagnostic.data",
          value: payload.diagnostic.data,
        });
      }
    },
    async get({ commit, state, dispatch }, payload) {
      $socket.on(`diagnostic-is-updated.${payload}`, function (data) {
        dispatch("silentRefresh", data);
      });
      updateField(state, { path: "fetched", value: false });
      updateField(state, { path: "diagnostic", value: null });
      updateField(state, {
        path: "repairtime_id",
        value: payload,
      });
      return await axios
        .get(this._vm.$apiURL + "/diagnostics/" + payload)
        .then((response) => {
          if (response.data && response.data.status === "success" && response.data.data) {
            commit("setDiagnostic", response.data.data);
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async update({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      updateField(state, {
        path: "repairtime_id",
        value: payload,
      });
      if (payload !== state.repairtime_id) {
        dispatch(
          "common/showError",
          {
            error:
              "Error on update. Id in state not equal passed to action. Try to refresh page",
          },
          { root: true }
        );
        return;
      }
      return await axios
        .put(this._vm.$apiURL + "/diagnostics/" + payload, state.diagnostic)
        .then((response) => {
          commit("setDiagnostic", response.data.data);
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
  },
};
